var React = require('react');

function AngleRightM (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.95801 3.73926C4.09473 3.60254 4.09473 3.41113 3.98535 3.27441L0.758789 0.102539C0.62207 -0.0341797 0.40332 -0.0341797 0.293945 0.102539L0.102539 0.293945C-0.0341797 0.430664 -0.0341797 0.62207 0.102539 0.758789L2.8916 3.49316L0.102539 6.25488C-0.0341797 6.3916 -0.0341797 6.58301 0.102539 6.71973L0.293945 6.91113C0.40332 7.04785 0.62207 7.04785 0.758789 6.91113L3.95801 3.73926Z","fill":"white"}));
}

AngleRightM.defaultProps = {"width":"100%","viewBox":"0 0 5 8","fill":"none"};

module.exports = AngleRightM;

AngleRightM.default = AngleRightM;
